import { render } from "./SharePage.vue?vue&type=template&id=5fe38554&scoped=true"
import script from "./SharePage.vue?vue&type=script&lang=js"
export * from "./SharePage.vue?vue&type=script&lang=js"

import "./SharePage.vue?vue&type=style&index=0&id=5fe38554&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe38554"]])

export default __exports__